type RaceEntryClassType = {
    name: string;
};

type RaceSeriesType = {
    name: string;
    entry_classes: RaceEntryClassType[];
};

type RaceRankType = {
    name: string;
    series_name: RaceSeriesType[];
};

type RaceCategoryType = {
    name: string;
    ranks: RaceRankType[];
};

type EntryInputType = {
    rank?: string;
    series_name?: string;
    entry_class?: string;
};

const entry: EntryInputType = window.entry;
const categories: RaceCategoryType[] = window.categories;

const categoryElement = document.querySelector<HTMLSelectElement>(
    ".js-cascade-select-category"
);
const rankElement = document.querySelector<HTMLSelectElement>(
    ".js-cascade-select-rank"
);
const seriesNameElement = document.querySelector<HTMLSelectElement>(
    ".js-cascade-select-series-name"
);
const entryClassElement = document.querySelector<HTMLSelectElement>(
    ".js-cascade-select-entry-class"
);

/**
 * レース情報のカスケードセレクト.
 *
 * @returns {void}
 */
const cascadeSelectRace = (): void => {
    if (
        !categoryElement ||
        !rankElement ||
        !seriesNameElement ||
        !entryClassElement
    )
        return;

    // セレクトボックスを初期化する.
    resetSelect(rankElement, "-");
    resetSelect(seriesNameElement, "-");
    resetSelect(entryClassElement, "-");

    categoryElement.addEventListener("change", () => {
        const category = categoryElement.value;

        resetSelect(rankElement, "-");
        resetSelect(seriesNameElement, "-");
        resetSelect(entryClassElement, "-");

        if (!category) return;

        const found = categories.find((c) => c.name === category);
        if (!found) return;

        const rankNames = found.ranks.map((r) => r.name);

        fillSelect(rankElement, rankNames);
    });

    rankElement.addEventListener("change", () => {
        const category = categoryElement.value;
        const rank = rankElement.value;

        resetSelect(seriesNameElement, "-");
        resetSelect(entryClassElement, "-");

        if (!category || !rank) return;

        const found = categories
            .find((c) => c.name === category)
            ?.ranks.find((r) => r.name === rank);

        if (!found) return;

        const seriesNames = found.series_name.map((s) => s.name);

        fillSelect(seriesNameElement, seriesNames);
    });

    seriesNameElement.addEventListener("change", () => {
        const category = categoryElement.value;
        const rank = rankElement.value;
        const series = seriesNameElement.value;

        resetSelect(entryClassElement, "-");

        if (!category || !rank || !series) return;

        const found = categories
            .find((c) => c.name === category)
            ?.ranks.find((r) => r.name === rank)
            ?.series_name.find((s) => s.name === series);

        if (!found) return;

        const classNames = found.entry_classes.map((c) => c.name);

        fillSelect(entryClassElement, classNames);
    });

    // 入力データを復元する.
    if (categoryElement.value) {
        categoryElement.dispatchEvent(new Event("change"));

        if (entry.rank) {
            rankElement.value = entry.rank;
            rankElement.dispatchEvent(new Event("change"));
        }

        if (entry.series_name) {
            seriesNameElement.value = entry.series_name;
            seriesNameElement.dispatchEvent(new Event("change"));
        }

        if (entry.entry_class) {
            entryClassElement.value = entry.entry_class;
        }
    }
};

/**
 * セレクトボックスをリセットする.
 *
 * @param   {HTMLSelectElement} element
 * @param   {string} placeholder
 * @returns {void}
 */
const resetSelect = (element: HTMLSelectElement, placeholder: string): void => {
    element.innerHTML = `<option value="">${placeholder}</option>`;
    element.disabled = true;
};

/**
 * 指定された値でセレクトボックスの option を埋める.
 *
 * @param   {HTMLSelectElement} element
 * @param   {string[]} items
 * @returns {void}
 */
const fillSelect = (element: HTMLSelectElement, items: string[]): void => {
    resetSelect(element, "-");
    items.forEach((value) => {
        const op = document.createElement("option");
        op.value = value;
        op.textContent = value;
        element.appendChild(op);
    });
    element.disabled = false;
};

/**
 * ランクの選択状態を更新する.
 *
 * @returns {void}
 */
const updateRank = (): void => {
    if (!rankElement || !categoryElement) return;

    rankElement.innerHTML = '<option value="">-</option>';

    const category = categoryElement.value;
    if (!category) return;

    const config = categories.find((c) => c.name === category);
    if (!config) return;

    config.ranks.forEach((r) => {
        const option = document.createElement("option");
        option.value = r.name;
        option.textContent = r.name;

        if (r.name === entry.rank) {
            option.selected = true;
        }

        rankElement.appendChild(option);
    });

    updateSeriesName();
};

/**
 * シリーズ名称の選択状態を更新する.
 *
 * @returns {void}
 */
const updateSeriesName = (): void => {
    if (!seriesNameElement || !categoryElement || !rankElement) return;

    seriesNameElement.innerHTML = '<option value="">-</option>';

    const category = categoryElement.value;
    const rank = rankElement.value;

    if (!category || !rank) return;

    const config = categories.find((c) => c.name === category);
    const rankData = config?.ranks.find((r) => r.name === rank);
    if (!rankData) return;

    rankData.series_name.forEach((s) => {
        const option = document.createElement("option");
        option.value = s.name;
        option.textContent = s.name;

        if (s.name === entry.series_name) {
            option.selected = true;
        }

        seriesNameElement.appendChild(option);
    });

    updateEntryClass();
};

/**
 * クラスの選択状態を更新する.
 *
 * @returns {void}
 */
function updateEntryClass() {
    if (
        !entryClassElement ||
        !categoryElement ||
        !rankElement ||
        !seriesNameElement
    )
        return;

    entryClassElement.innerHTML = '<option value="">-</option>';

    const category = categoryElement.value;
    const rank = rankElement.value;
    const series = seriesNameElement.value;

    if (!category || !rank || !series) return;

    const config = categories.find((c) => c.name === category);
    const rankData = config?.ranks.find((r) => r.name === rank);
    const seriesData = rankData?.series_name.find((s) => s.name === series);
    if (!seriesData) return;

    seriesData.entry_classes.forEach((c) => {
        const option = document.createElement("option");
        option.value = c.name;
        option.textContent = c.name;

        if (c.name === entry.entry_class) {
            option.selected = true;
        }

        entryClassElement.appendChild(option);
    });
}

export default cascadeSelectRace;
